import {
  ProductModule,
  procurementThresholdBufferPct,
} from '@erp/shared-types';
import { useGetModuleConfig } from '@/api/org/config/modules';

/** The org's buffer share above the PO minimum and prepaid freight (GEN-2931). */
export function useThresholdBufferPct(): number {
  const { data } = useGetModuleConfig(ProductModule.PROCUREMENT);
  return procurementThresholdBufferPct(data?.config?.procurement);
}
